import { useMemo } from 'react';

import { useWorkstations } from './useWorkstations';

const EMPTY_PRINTERS = [];
export const useWorkstation = (options: { hostname?: string }) => {
  const { hostname } = options;
  const { query, workstations } = useWorkstations();

  const workstation = workstations.find((w) => w.hostname === hostname);
  const printers = workstation?.printers ?? EMPTY_PRINTERS;
  const printerNames = useMemo(() => printers.map((p) => p.printer_name).sort(), [printers]);

  return { printerNames, printers, query, workstation };
};
